// Canonical backend action names, centralized here so route/nav/list-gating logic (and any UI
// code) reference one definition instead of scattering string literals like "list"/"view".
export const ACTIONS = {
  LIST: "list",
  CREATE: "create",
  VIEW: "view",
  OLD_DASHBOARD: "old_dashboard",
  NEW_DASHBOARD: "new_dashboard",
  ADD: "add",
} as const;

// e.g. `if (hasModuleAction(moduleActions, ACTIONS.LIST)) return <DataTable ... />;`
export const hasModuleAction = (moduleActions: string[] | undefined, actionName: string) =>
  Boolean(moduleActions?.includes(actionName));
